import client from '../ApolloClient'
import gql from 'graphql-tag'
import { failFetch } from '../Actions/Other'
import {
  GENERATE_USER_REPORT,
  GENERATE_CONTENT_REPORT,
  GENERATE_SMS_USERS_REPORT,
  loadGenerateUserReport,
  loadGenerateContentReport,
  loadSMSUsersReport
} from '../Actions/GenerateReport'
import { Subject, filter, mergeMap, map } from 'rxjs'

const generateContentReportQuery = gql`query generateContentAnalyticsCSV(
    $accountId: ID!,
    $startDate: DateTime!,
    $endDate: DateTime!,
    $location: ContentLocation!,
    $sortField: String,
    $sortDirection: String,
    $appProfileIds: [ID],
    $groupIds:[ID],
    ) {
    generateContentAnalyticsCSV(
    accountId: $accountId,
    startDate: $startDate,
    endDate: $endDate,
    location: $location,
    sortField: $sortField,
    sortDirection: $sortDirection,
    appProfileIds: $appProfileIds,
    groupIds: $groupIds
    )
}`

/**
  * generateContentReportEpic
  * @desc action Observer that sends a query and processes result if receiving a content report action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const generateContentReportEpic = action$ =>
  action$.pipe(
    filter(action => action.type === GENERATE_CONTENT_REPORT),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: generateContentReportQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadGenerateContentReport(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

const generateUserReportQuery = gql`query generateUserAnalyticsCSV(
    $accountId: String!,
    $startDate: DateTime!,
    $endDate: DateTime!,
    $userAdminType: UserAdminType,
    $onlyAdmins: Boolean,
    $appProfileIds: [ID!],
    $groupIds: [ID!],
    $appType: AppType!,
    $sortField: String,
    $sortDirection: SortDirection) {
  generateUserAnalyticsCSV (accountId: $accountId,
    startDate: $startDate,
    endDate: $endDate,
    userAdminType: $userAdminType,
    onlyAdmins: $onlyAdmins,
    appProfileIds: $appProfileIds,
    groupIds: $groupIds,
    appType: $appType,
    sortField: $sortField,
    sortDirection: $sortDirection)
}`

/**
  * generateUserReportEpic
  * @desc action Observer that sends a query and processes result if the action is a generate user report action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const generateUserReportEpic = action$ =>
  action$.pipe(
    filter(action => action.type === GENERATE_USER_REPORT),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: generateUserReportQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadGenerateUserReport(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

const generateSMSUserReportQuery = gql`query getSmsUsersReportCSV($alertId: String!, $subscribed: Boolean!, $limit: Int!, $offset: Int!) {
  getSmsUsersReportCSV(alertId: $alertId, subscribed: $subscribed, limit: $limit, offset: $offset)
}`

/**
 * generateSMSUsersReportEpic
 * @desc action Observer that sends a query and processes result if the action is a generate sms user report action
 * @param {Observable<action>} action$ Action Observable stream
 * @return {action}
 */
export const generateSMSUsersReportEpic = action$ =>
  action$.pipe(
    filter(action => action.type === GENERATE_SMS_USERS_REPORT),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: generateSMSUserReportQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadSMSUsersReport(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )
